module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAANlBMVEUAAABwr/dwrfJxrvJxrvNwr/9xrvJwrfFwrvFxrfFwr/JxrfFxrvJwrfJwr/RxrvJwr/NxrvJhZEcUAAAAEXRSTlMAIGDQkBCggHDgT/CwrzDAQHVJgkMAAAB/SURBVBjTTY4BDsUgCEMB0SFON+9/2d+I219jUlvJQ1qSNGcSenWeg2ic/clawouGc810935TbhwAJW7uSBqY48B5DTIl7yA7qW0GeCmBXHlvNbS4W6FQThK/y/RvvpmtoEEuxmuy6sAM3odWQTE3+llI0tR5Jdcmm3FN6FqMH7i7A1/6T93YAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/mine/区域.png
// module id = 1367
// module chunks = 5